// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
#topDateBar {
  display: flex;
  width: 95%;
  margin: 0 auto;
  margin-bottom: 1%;
  margin-left: 3.5%;
}
@media (max-width: 600px) {
  #topDateBar {
    display: block;
  }
}
#topDateBar #siteSelection {
  display: flex;
}
#topDateBar #siteSelection select {
  border: 2px solid #2c53a0;
  border-radius: 15px;
}
#topDateBar #siteSelection h2 {
  border: 2px solid #2c53a0;
  border-radius: 15px;
  padding-left: 50px;
  padding-right: 50px;
  background-color: #fff;
  margin-top: 5%;
  height: 75%;
  line-height: 40px;
}
@media (max-width: 600px) {
  #topDateBar #siteSelection {
    margin-top: 5%;
  }
  #topDateBar #siteSelection select {
    width: 80vw;
    margin: 0 auto;
    text-align: center;
  }
}
#topDateBar #repDate {
  margin-left: 1%;
  display: flex;
}
#topDateBar #repDate input {
  border: 2px solid #2c53a0;
  border-radius: 15px;
  padding-top: 5%;
  max-width: 20%;
  padding-top: 1%;
  padding-bottom: 1%;
  margin-right: 1%;
  margin-left: 1%;
}
@media (max-width: 600px) {
  #topDateBar #repDate {
    margin-left: 12%;
    margin-top: 2%;
  }
  #topDateBar #repDate input {
    min-width: 30vw;
  }
}

#mainData {
  margin: 0% auto;
  min-height: 61vh;
  display: flex;
  justify-content: space-between;
  width: 95%;
  border: 2px solid #2c53a0;
  border-radius: 8px;
}
@media (max-width: 600px) {
  #mainData {
    display: block;
  }
}
#mainData #shifts {
  width: 30%;
  border-right: 2px solid #2c53a0;
}
@media (max-width: 600px) {
  #mainData #shifts {
    width: 100%;
  }
}
#mainData #shifts h2 {
  color: #fff;
  background-color: #2c53a0;
  text-align: center;
  width: 100%;
  padding-bottom: 2%;
  padding-top: 3%;
  margin-top: 0%;
  border-bottom: 2px solid #2c53a0;
}
#mainData #shifts #shiftDate {
  margin-top: -3.75%;
  text-align: center;
  padding: 1%;
  background-color: #2c53a0;
  border-top: 1px solid #64c4e0;
}
#mainData #shifts .noShifts {
  margin-top: 35%;
  color: #4d4d4d;
  text-align: center;
  width: 100%;
}
#mainData #shifts #shiftAccord {
  height: 51vh;
  overflow-y: auto;
}
@media (max-width: 600px) {
  #mainData #shifts #shiftAccord {
    height: 25vh;
    border-bottom: 1px solid #2c53a0;
    margin-bottom: 5%;
  }
}
#mainData #shifts #shiftAccord .shift {
  width: 90%;
  margin: 0 auto;
  margin-bottom: 1%;
}
#mainData #shifts #shiftAccord .shiftData {
  display: flex;
  justify-content: space-between;
  width: 95%;
  margin: 0 auto;
}
@media (max-width: 600px) {
  #mainData #shifts #shiftAccord .shiftData {
    font-size: 0.8rem;
  }
}
@media (min-width: 900px) and (max-width: 1300px) {
  #mainData #shifts #shiftAccord .shiftData {
    font-size: 0.6rem;
  }
}
#mainData #shifts .transactionJournal {
  display: flex;
  justify-content: space-between;
}
#mainData #information {
  width: 70%;
  min-height: 61vh;
}
@media (max-width: 600px) {
  #mainData #information {
    width: 100%;
  }
}
#mainData #information #searchBar {
  display: flex;
  justify-content: space-evenly;
  border-bottom: 2px solid #2c53a0;
  padding-bottom: 1.3%;
  background-color: #2c53a0;
}
#mainData #information #searchBar input {
  margin-top: 1%;
  border: 2px solid #64c4e0;
  border-radius: 15px;
  padding-top: 2%;
  padding-bottom: 2%;
  margin-bottom: -1.5%;
  width: 30vw;
}
#mainData #information #searchBar h4 {
  color: #fff;
  text-align: center;
  margin-bottom: -5%;
}
#mainData #information #searchBar h4 span {
  color: #64c4e0;
  text-decoration: underline;
}
#mainData #information .filters {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 1vh;
}
#mainData #information .filters .type_filter {
  height: 4vh;
  width: 32%;
  border-radius: 5px;
}
#mainData #information .filters .pump_filter {
  width: 32%;
  display: flex;
  display: flex;
  justify-content: space-between;
}
#mainData #information .filters .pump_filter input {
  width: 80%;
  border-radius: 5px;
}
#mainData #information .filters .price_filter {
  width: 32%;
  display: flex;
  justify-content: space-around;
}
#mainData #information .filters .price_filter input {
  width: 37%;
  border-radius: 5px;
}
#mainData #information .alert_area {
  height: 8vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
#mainData #information .fuel_table {
  margin-top: 1vh;
  width: 95%;
  margin: 1vh auto;
}
#mainData #information .fuel_table table {
  table-layout: fixed;
  background-color: #fff;
  border-collapse: collapse;
  color: #4d4d4d;
  width: 95%;
}
#mainData #information .fuel_table table thead {
  border-bottom: 1px solid #4d4d4d;
  text-align: center;
}
#mainData #information .fuel_table table tbody {
  text-align: center;
}
#mainData #information .fuel_table table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
#mainData #information .fuel_table table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}
#mainData #information .fuel_table table tbody tr input {
  width: 20%;
  margin: 0 auto;
  text-align: center;
}
#mainData #information .fuel_table .fuel_accordian p {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c53a0;
  width: 30%;
  display: flex;
}
#mainData #information .fuel_table .fuel_accordian p span {
  color: black;
}
#mainData #information .loaderIcon {
  margin-top: 15%;
}
#mainData #information #transData {
  max-height: 55vh;
  overflow-y: auto;
}
#mainData #information #transData .transaction {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 0.5%;
}
@media (max-width: 600px) {
  #mainData #information #transData .transaction {
    width: 95%;
  }
}
#mainData #information #transData .transaction .transactionData {
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
}
#mainData #information #transData .transaction .transactionData span {
  color: #2c53a0;
  font-weight: bold;
}
@media (max-width: 600px) {
  #mainData #information #transData .transaction .transactionData {
    font-size: 0.6rem;
  }
}
@media (min-width: 900px) and (max-width: 1300px) {
  #mainData #information #transData .transaction .transactionData {
    font-size: 0.8rem;
  }
}
@keyframes move-dot1 {
  0% {
    transform: translateX(-50%) translateY(-50%);
  }
  20% {
    transform: translateX(-50%) translateY(30%);
  }
  100% {
    transform: translateX(-50%) translateY(30%);
  }
}
@keyframes move-dot2 {
  0% {
    transform: translateX(-50%) translateY(-50%);
  }
  15% {
    transform: translateX(-50%) translateY(-10%);
  }
  30% {
    transform: translateX(-10%) translateY(-10%);
  }
  100% {
    transform: translateX(-10%) translateY(-10%);
  }
}
@keyframes pulsate {
  0% {
    box-shadow: rgba(0, 0, 0, 0) 0px 3px 18px;
  }
  25% {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 3px 18px;
  }
  50% {
    box-shadow: rgba(0, 0, 0, 0.5) 0px 3px 18px;
  }
  75% {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 3px 18px;
  }
  100% {
    box-shadow: rgba(0, 0, 0, 0) 0px 3px 18px;
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
#mainData #information body {
  background: #eee;
}
#mainData #information .animation-example {
  position: relative;
  top: 45%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  height: 30vmin;
  width: 30vmin;
}
@media (max-width: 600px) {
  #mainData #information .animation-example {
    margin-top: 65%;
  }
}
#mainData #information .animation-example > .item {
  position: absolute;
  top: 0;
  left: 50%;
  height: 50%;
  width: 50%;
  transform: translateX(-50%);
  transform-origin: 50% 100%;
  pointer-events: none;
}
#mainData #information .animation-example > .item:nth-child(2) {
  transform: translateX(-50%) rotate(90deg);
}
#mainData #information .animation-example > .item:nth-child(3) {
  transform: translateX(-50%) rotate(180deg);
}
#mainData #information .animation-example > .item:nth-child(4) {
  transform: translateX(-50%) rotate(270deg);
}
#mainData #information .animation-example > .item > .line {
  height: 100%;
  width: calc(50% + 1px);
  border-right: 2px dashed #2c53a0;
}
#mainData #information .animation-example > .item > .dot {
  position: absolute;
  left: 50%;
  top: 10%;
  transform: translateX(-50%) translateY(-50%);
  height: 100%;
  width: 100%;
  animation: move-dot1 5.5s linear infinite;
}
#mainData #information .animation-example > .item > .dot::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  height: 5%;
  width: 5%;
  background: #64c4e0;
  border: 2px solid #2c53a0;
  border-radius: 50%;
}
#mainData #information .animation-example > .item > .circle {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 20%;
  width: 20%;
  border-radius: 50%;
  background: #2c53a0;
  animation: pulsate 1s infinite;
}
#mainData #information .animation-example > .item.-type2 {
  top: 0;
  left: 0;
  transform: none;
  transform-origin: 100% 100%;
}
#mainData #information .animation-example > .item.-type2:nth-child(5) {
  transform: scaleX(-100%);
}
#mainData #information .animation-example > .item.-type2:nth-child(6) {
  transform: scaleX(-100%) scaleY(-100%);
}
#mainData #information .animation-example > .item.-type2:nth-child(7) {
  transform: scaleY(-100%);
}
#mainData #information .animation-example > .item.-type2 > .line {
  position: absolute;
  top: 30%;
  left: calc(30% - 1px);
  width: 70%;
  height: 40%;
  border-right: none;
  border-left: 2px dashed #2c53a0;
  border-bottom: 2px dashed #2c53a0;
}
#mainData #information .animation-example > .item.-type2 > .dot {
  top: 30%;
  left: 30%;
  animation: move-dot2 4s linear infinite;
}
#mainData #information .animation-example > .item.-type2 > .circle {
  top: 30%;
  left: 30%;
  transform: translateX(-50%) translateY(-50%);
}
#mainData #information .animation-example > .item:nth-of-type(1) > .dot {
  animation-delay: 0;
}
#mainData #information .animation-example > .item:nth-of-type(7) > .dot {
  animation-delay: 0.5s;
}
#mainData #information .animation-example > .item:nth-of-type(2) > .dot {
  animation-delay: 1s;
}
#mainData #information .animation-example > .item:nth-of-type(6) > .dot {
  animation-delay: 1.5s;
}
#mainData #information .animation-example > .item:nth-of-type(3) > .dot {
  animation-delay: 2s;
}
#mainData #information .animation-example > .item:nth-of-type(5) > .dot {
  animation-delay: 2.5s;
}
#mainData #information .animation-example > .item:nth-of-type(4) > .dot {
  animation-delay: 3s;
}
#mainData #information .animation-example > .item:nth-of-type(8) > .dot {
  animation-delay: 3.5s;
}
#mainData #information .animation-example > .center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  height: 50%;
  width: 50%;
}
#mainData #information .animation-example > .center > .circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  border-radius: 50%;
}
#mainData #information .animation-example > .center > .circle:nth-child(1) {
  height: 100%;
  width: 100%;
  background: #64c4e0;
  box-shadow: 0 0 3vmin rgba(0, 0, 0, 0.5);
}
#mainData #information .animation-example > .center > .circle:nth-child(2) {
  height: 80%;
  width: 80%;
  border: 2px solid #2c53a0;
}
#mainData #information .animation-example > .center > .circle:nth-child(3) {
  height: 50%;
  width: 50%;
  background: #2c53a0;
}

.itemTable p {
  text-align: center;
  text-decoration: underline;
  color: black;
  font-weight: bolder;
}
.itemTable table {
  width: 90%;
  margin: auto;
  table-layout: fixed;
  border-collapse: collapse;
  background-color: #fff;
  color: black;
}
.itemTable table thead {
  background-color: #2c53a0;
  color: #fff;
}
.itemTable table tbody tr {
  border-bottom: 1px solid #4d4d4d;
}
@media (max-width: 600px) {
  .itemTable table tbody tr {
    font-size: 0.6rem;
  }
}
.itemTable table tbody tr td {
  text-align: center;
}
.itemTable table tbody .selected__row__shift {
  background-color: #2c53a0;
  color: #fff;
}

.summary {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 600px) {
  .summary {
    display: block;
  }
  .summary #itemSearch {
    margin-left: -15%;
    margin-bottom: -70%;
  }
  .summary #catSearch {
    margin-left: -38%;
    margin-bottom: -195%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/managerZone/posExplorer/posExplorer.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAIA;EACI,aAAA;EAEA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAHJ;AAII;EAPJ;IAQQ,cAAA;EADN;AACF;AAGI;EACI,aAAA;AADR;AAGQ;EACI,yBAAA;EACA,mBAAA;AADZ;AAIQ;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;AAFZ;AAKQ;EAnBJ;IAqBQ,cAAA;EAHV;EAKU;IACI,WAAA;IACA,cAAA;IACA,kBAAA;EAHd;AACF;AAOI;EACI,eAAA;EACA,aAAA;AALR;AAOQ;EACI,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACH,kBAAA;EACG,gBAAA;EACA,eAAA;AALZ;AAQQ;EAfJ;IAgBQ,gBAAA;IACA,cAAA;EALV;EAMU;IACI,eAAA;EAJd;AACF;;AASA;EACI,eAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;AANJ;AAQI;EATJ;IAUQ,cAAA;EALN;AACF;AAOI;EACI,UAAA;EACA,+BAAA;AALR;AAOQ;EAJJ;IAKQ,WAAA;EAJV;AACF;AAMQ;EACI,WAAA;EACA,yBDlGA;ECmGA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;AAJZ;AAOQ;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBD/GA;ECgHA,6BAAA;AALZ;AAQQ;EACI,eAAA;EACA,cDlHA;ECmHA,kBAAA;EACA,WAAA;AANZ;AASQ;EACI,YAAA;EACA,gBAAA;AAPZ;AASY;EAJJ;IAKQ,YAAA;IACA,gCAAA;IACA,iBAAA;EANd;AACF;AAQY;EACI,UAAA;EACA,cAAA;EACA,iBAAA;AANhB;AASY;EACI,aAAA;EACA,8BAAA;EACA,UAAA;EACA,cAAA;AAPhB;AASgB;EANJ;IAOQ,iBAAA;EANlB;AACF;AAQgB;EAVJ;IAWQ,iBAAA;EALlB;AACF;AASQ;EACI,aAAA;EACA,8BAAA;AAPZ;AAWI;EACI,UAAA;EACA,gBAAA;AATR;AAWQ;EAJJ;IAKQ,WAAA;EARV;AACF;AAUQ;EACI,aAAA;EACA,6BAAA;EACA,gCAAA;EACA,oBAAA;EACA,yBD7KA;ACqKZ;AAUY;EACI,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;AARhB;AAWY;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;AAThB;AAWgB;EACI,cD9LP;EC+LO,0BAAA;AATpB;AAcQ;EACI,aAAA;EACA,WAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;AAZZ;AAcY;EACI,WAAA;EACA,UAAA;EACA,kBAAA;AAZhB;AAcY;EACI,UAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;AAZhB;AAagB;EACI,UAAA;EACA,kBAAA;AAXpB;AAcY;EACI,UAAA;EACA,aAAA;EACA,6BAAA;AAZhB;AAagB;EACI,UAAA;EACA,kBAAA;AAXpB;AAgBQ;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAdZ;AAiBQ;EACI,eAAA;EACA,UAAA;EACA,gBAAA;AAfZ;AAiBY;ED3GR,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvIQ;ECiPI,UAAA;AAZhB;AD7FI;EACI,gCAAA;EACA,kBAAA;AC+FR;AD7FI;EACI,kBAAA;AC+FR;AD9FQ;EACI,gCAAA;ACgGZ;AD/FY;EACI,yBAAA;ACiGhB;AD/FY;EACI,UAAA;EACA,cAAA;EACA,kBAAA;ACiGhB;AAFgB;EACI,iBAAA;EACA,gBAAA;EACA,cD3PR;EC4PQ,UAAA;EACA,aAAA;AAIpB;AAFoB;EACI,YAAA;AAIxB;AACQ;EACI,eAAA;AACZ;AAEQ;EACI,gBAAA;EACA,gBAAA;AAAZ;AAEY;EACI,UAAA;EACA,cAAA;EACA,mBAAA;AAAhB;AAEgB;EALJ;IAMQ,UAAA;EAClB;AACF;AACgB;EACI,aAAA;EACA,8BAAA;EACA,UAAA;EACA,cAAA;AACpB;AACoB;EACI,cD7RZ;EC8RY,iBAAA;AACxB;AAEoB;EAXJ;IAYQ,iBAAA;EACtB;AACF;AACoB;EAfJ;IAgBQ,iBAAA;EAEtB;AACF;AAGQ;EACI;IACI,4CAAA;EADd;EAIU;IACI,2CAAA;EAFd;EAKU;IACI,2CAAA;EAHd;AACF;AAMQ;EACI;IACI,4CAAA;EAJd;EAOU;IACI,4CAAA;EALd;EAQU;IACI,4CAAA;EANd;EASU;IACI,4CAAA;EAPd;AACF;AAUQ;EACI;IACI,yCAAA;EARd;EAWU;IACI,4CAAA;EATd;EAYU;IACI,2CAAA;EAVd;EAaU;IACI,4CAAA;EAXd;EAcU;IACI,yCAAA;EAZd;AACF;AAeQ;EACI;IACI,uBAAA;EAbd;EAgBU;IACI,yBAAA;EAdd;AACF;AAiBQ;EACI,gBAAA;AAfZ;AAkBQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,cAAA;EACA,aAAA;AAhBZ;AAkBY;EARJ;IASQ,eAAA;EAfd;AACF;AAmBY;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,0BAAA;EACA,oBAAA;AAjBhB;AAoBY;EACI,yCAAA;AAlBhB;AAqBY;EACI,0CAAA;AAnBhB;AAsBY;EACI,0CAAA;AApBhB;AAuBY;EACI,YAAA;EACA,sBAAA;EACA,gCAAA;AArBhB;AAwBY;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,4CAAA;EACA,YAAA;EACA,WAAA;EACA,yCAAA;AAtBhB;AAyBY;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,UAAA;EACA,SAAA;EACA,mBD5aH;EC6aG,yBAAA;EACA,kBAAA;AAvBhB;AA0BY;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,mBD1bJ;EC2bI,8BAAA;AAxBhB;AA2BY;EACI,MAAA;EACA,OAAA;EACA,eAAA;EACA,2BAAA;AAzBhB;AA4BY;EACI,wBAAA;AA1BhB;AA6BY;EACI,sCAAA;AA3BhB;AA8BY;EACI,wBAAA;AA5BhB;AA+BY;EACI,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,iCAAA;AA7BhB;AAgCY;EACI,QAAA;EACA,SAAA;EACA,uCAAA;AA9BhB;AAiCY;EACI,QAAA;EACA,SAAA;EACA,4CAAA;AA/BhB;AAkCY;EACI,kBAAA;AAhChB;AAmCY;EACI,qBAAA;AAjChB;AAoCY;EACI,mBAAA;AAlChB;AAqCY;EACI,qBAAA;AAnChB;AAsCY;EACI,mBAAA;AApChB;AAuCY;EACI,qBAAA;AArChB;AAwCY;EACI,mBAAA;AAtChB;AAyCY;EACI,qBAAA;AAvChB;AA0CY;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,WAAA;EACA,UAAA;AAxChB;AA2CY;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,kBAAA;AAzChB;AA4CY;EACI,YAAA;EACA,WAAA;EACA,mBD3hBH;EC4hBG,wCAAA;AA1ChB;AA6CY;EACI,WAAA;EACA,UAAA;EACA,yBAAA;AA3ChB;AA8CY;EACI,WAAA;EACA,UAAA;EACA,mBDziBJ;AC6fZ;;AAmDI;EACI,kBAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;AAhDR;AAmDI;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;AAjDR;AAmDQ;EACI,yBDhkBA;ECikBA,WAAA;AAjDZ;AAqDY;EACI,gCAAA;AAnDhB;AAqDgB;EAHJ;IAIQ,iBAAA;EAlDlB;AACF;AAoDgB;EACI,kBAAA;AAlDpB;AAsDY;EACI,yBDllBJ;ECmlBI,WAAA;AApDhB;;AA0DA;EACI,aAAA;EACA,8BAAA;AAvDJ;AAyDI;EAJJ;IAKQ,cAAA;EAtDN;EAwDM;IACI,iBAAA;IACA,mBAAA;EAtDV;EAyDM;IACI,iBAAA;IACA,oBAAA;EAvDV;AACF","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../../variables.scss\";\n\n$size: 150px;\n\n$d: $size * 0.5;\n$ang: 0.7071;\n$a: $d * $ang;\n\n#topDateBar {\n    display: flex;\n// justify-content: space-between;\n    width: 95%;\n    margin: 0 auto;\n    margin-bottom: 1%; \n    margin-left: 3.5%;\n    @media (max-width: $mobile) {\n        display: block;\n    }\n\n    #siteSelection {\n        display: flex;\n\n        select {\n            border: 2px solid $nitroDark;\n            border-radius: 15px;\n        }\n\n        h2 {\n            border: 2px solid $nitroDark;\n            border-radius: 15px;\n            padding-left: 50px;\n            padding-right: 50px;\n            background-color: #fff;\n            margin-top: 5%;\n            height: 75%;\n            line-height: 40px;\n        }\n\n        @media (max-width: $mobile) {\n            // margin-left: 4%;\n            margin-top: 5%;\n\n            select{\n                width: 80vw;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n\n    #repDate {\n        margin-left: 1%;\n        display: flex;\n\n        input {\n            border: 2px solid $nitroDark;\n            border-radius: 15px;\n            padding-top: 5%;\n            max-width: 20%;\t            \n            padding-top: 1%;\n\t        padding-bottom: 1%;\n            margin-right: 1%;\n            margin-left: 1%;\n        }\n\n        @media (max-width: $mobile) {\n            margin-left: 12%;\n            margin-top: 2%;\n            input {\n                min-width: 30vw;\n            }\n        }\n    }\n}\n\n#mainData {\n    margin: 0% auto;\n    min-height: 61vh;\n    display: flex;\n    justify-content: space-between;\n    width: 95%;\n    border: 2px solid $nitroDark;\n    border-radius: 8px;\n\n    @media (max-width: $mobile) {\n        display: block;\n    }\n\n    #shifts {\n        width: 30%;\n        border-right: 2px solid $nitroDark;\n\n        @media (max-width: $mobile) {\n            width: 100%;\n        }\n\n        h2 {\n            color: #fff;\n            background-color: $nitroDark;\n            text-align: center;\n            width: 100%;\n            padding-bottom: 2%;\n            padding-top: 3%;\n            margin-top: 0%;\n            border-bottom: 2px solid $nitroDark;\n        }\n\n        #shiftDate {\n            margin-top: -3.75%;\n            text-align: center;\n            padding: 1%;\n            background-color: $nitroDark;\n            border-top: 1px solid $nitroLight;\n        }\n\n        .noShifts {\n            margin-top: 35%;\n            color: $fontColor;\n            text-align: center;\n            width: 100%;\n        }\n\n        #shiftAccord {\n            height: 51vh;\n            overflow-y: auto;\n\n            @media (max-width: $mobile) {\n                height: 25vh;\n                border-bottom: 1px solid $nitroDark;\n                margin-bottom: 5%;\n            }\n\n            .shift {\n                width: 90%;\n                margin: 0 auto;\n                margin-bottom: 1%;\n            }\n\n            .shiftData {\n                display: flex;\n                justify-content: space-between;\n                width: 95%;\n                margin: 0 auto;\n\n                @media (max-width: $mobile) {\n                    font-size: 0.8rem;\n                }\n\n                @media (min-width: $laptop) and (max-width: $landsTabletMax) {\n                    font-size: 0.6rem;\n                }\n            }\n        }\n\n        .transactionJournal {\n            display: flex;\n            justify-content: space-between;\n        }\n    }\n\n    #information {\n        width: 70%;\n        min-height: 61vh;\n\n        @media (max-width: $mobile) {\n            width: 100%;\n        }\n\n        #searchBar {\n            display: flex;\n            justify-content: space-evenly;\n            border-bottom: 2px solid $nitroDark;\n            padding-bottom: 1.3%;\n            background-color: $nitroDark;\n\n            input {\n                margin-top: 1%;\n                border: 2px solid $nitroLight;\n                border-radius: 15px;\n                padding-top: 2%;\n                padding-bottom: 2%;\n                margin-bottom: -1.5%;\n                width: 30vw;\n            }\n\n            h4 {\n                color: #fff;\n                text-align: center;\n                margin-bottom: -5%;\n\n                span {\n                    color: $nitroLight;\n                    text-decoration: underline;\n                }\n            }\n        }\n\n        .filters {\n            display: flex;\n            width: 100%;\n            justify-content: space-evenly;\n            align-items: center;\n            margin-top: 1vh;\n\n            .type_filter {\n                height: 4vh;\n                width: 32%;\n                border-radius: 5px;\n            }\n            .pump_filter {\n                width: 32%;\n                display: flex;\n                display: flex;\n                justify-content: space-between;\n                input {\n                    width: 80%;\n                    border-radius: 5px;\n                }\n            }\n            .price_filter {\n                width: 32%;\n                display: flex;\n                justify-content: space-around;\n                input {\n                    width: 37%;\n                    border-radius: 5px;\n                }\n            }\n        }\n\n        .alert_area {\n            height: 8vh;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n        }\n\n        .fuel_table {\n            margin-top: 1vh;\n            width: 95%;\n            margin: 1vh auto;\n\n            table {\n                @include table;\n                width: 95%;\n            }\n\n            .fuel_accordian {\n                p {\n                    font-size: 1.1rem;\n                    font-weight: 600;\n                    color: $nitroDark;\n                    width: 30%;\n                    display: flex;\n\n                    span {\n                        color: black;\n                    }\n                }\n            }\n        }\n        .loaderIcon {\n            margin-top: 15%;\n        }\n\n        #transData {\n            max-height: 55vh;\n            overflow-y: auto;\n\n            .transaction {\n                width: 80%;\n                margin: 0 auto;\n                margin-bottom: 0.5%;\n\n                @media (max-width: $mobile) {\n                    width: 95%;\n                }\n\n                .transactionData {\n                    display: flex;\n                    justify-content: space-between;\n                    width: 90%;\n                    margin: 0 auto;\n\n                    span {\n                        color: $nitroDark;\n                        font-weight: bold;\n                    }\n\n                    @media (max-width: $mobile) {\n                        font-size: 0.6rem;\n                    }\n\n                    @media (min-width: $laptop) and (max-width: $landsTabletMax) {\n                        font-size: 0.8rem;\n                    }\n                }\n            }\n        }\n\n        @keyframes move-dot1 {\n            0% {\n                transform: translateX(-50%) translateY(-50%);\n            }\n\n            20% {\n                transform: translateX(-50%) translateY(30%);\n            }\n\n            100% {\n                transform: translateX(-50%) translateY(30%);\n            }\n        }\n\n        @keyframes move-dot2 {\n            0% {\n                transform: translateX(-50%) translateY(-50%);\n            }\n\n            15% {\n                transform: translateX(-50%) translateY(-10%);\n            }\n\n            30% {\n                transform: translateX(-10%) translateY(-10%);\n            }\n\n            100% {\n                transform: translateX(-10%) translateY(-10%);\n            }\n        }\n\n        @keyframes pulsate {\n            0% {\n                box-shadow: rgba(0, 0, 0, 0) 0px 3px 18px;\n            }\n\n            25% {\n                box-shadow: rgba(0, 0, 0, 0.25) 0px 3px 18px;\n            }\n\n            50% {\n                box-shadow: rgba(0, 0, 0, 0.5) 0px 3px 18px;\n            }\n\n            75% {\n                box-shadow: rgba(0, 0, 0, 0.25) 0px 3px 18px;\n            }\n\n            100% {\n                box-shadow: rgba(0, 0, 0, 0) 0px 3px 18px;\n            }\n        }\n\n        @keyframes spin {\n            from {\n                transform: rotate(0deg);\n            }\n\n            to {\n                transform: rotate(360deg);\n            }\n        }\n\n        body {\n            background: #eee;\n        }\n\n        .animation-example {\n            position: relative;\n            top: 45%;\n            left: 50%;\n            transform: translateX(-50%) translateY(-50%);\n            height: 30vmin;\n            width: 30vmin;\n\n            @media (max-width: $mobile) {\n                margin-top: 65%;\n            }\n\n            // animation: spin 15s linear infinite;\n\n            > .item {\n                position: absolute;\n                top: 0;\n                left: 50%;\n                height: 50%;\n                width: 50%;\n                transform: translateX(-50%);\n                transform-origin: 50% 100%;\n                pointer-events: none;\n            }\n\n            > .item:nth-child(2) {\n                transform: translateX(-50%) rotate(90deg);\n            }\n\n            > .item:nth-child(3) {\n                transform: translateX(-50%) rotate(180deg);\n            }\n\n            > .item:nth-child(4) {\n                transform: translateX(-50%) rotate(270deg);\n            }\n\n            > .item > .line {\n                height: 100%;\n                width: calc(50% + 1px);\n                border-right: 2px dashed $nitroDark;\n            }\n\n            > .item > .dot {\n                position: absolute;\n                left: 50%;\n                top: 10%;\n                transform: translateX(-50%) translateY(-50%);\n                height: 100%;\n                width: 100%;\n                animation: move-dot1 5.5s linear infinite;\n            }\n\n            > .item > .dot::after {\n                content: \"\";\n                position: absolute;\n                top: 50%;\n                left: 50%;\n                transform: translateX(-50%) translateY(-50%);\n                height: 5%;\n                width: 5%;\n                background: $nitroLight;\n                border: 2px solid $nitroDark;\n                border-radius: 50%;\n            }\n\n            > .item > .circle {\n                position: absolute;\n                top: 0;\n                left: 50%;\n                transform: translateX(-50%);\n                height: 20%;\n                width: 20%;\n                border-radius: 50%;\n                background: $nitroDark;\n                animation: pulsate 1s infinite;\n            }\n\n            > .item.-type2 {\n                top: 0;\n                left: 0;\n                transform: none;\n                transform-origin: 100% 100%;\n            }\n\n            > .item.-type2:nth-child(5) {\n                transform: scaleX(-100%);\n            }\n\n            > .item.-type2:nth-child(6) {\n                transform: scaleX(-100%) scaleY(-100%);\n            }\n\n            > .item.-type2:nth-child(7) {\n                transform: scaleY(-100%);\n            }\n\n            > .item.-type2 > .line {\n                position: absolute;\n                top: 30%;\n                left: calc(30% - 1px);\n                width: 70%;\n                height: 40%;\n                border-right: none;\n                border-left: 2px dashed $nitroDark;\n                border-bottom: 2px dashed $nitroDark;\n            }\n\n            > .item.-type2 > .dot {\n                top: 30%;\n                left: 30%;\n                animation: move-dot2 4s linear infinite;\n            }\n\n            > .item.-type2 > .circle {\n                top: 30%;\n                left: 30%;\n                transform: translateX(-50%) translateY(-50%);\n            }\n\n            > .item:nth-of-type(1) > .dot {\n                animation-delay: 0;\n            }\n\n            > .item:nth-of-type(7) > .dot {\n                animation-delay: 0.5s;\n            }\n\n            > .item:nth-of-type(2) > .dot {\n                animation-delay: 1s;\n            }\n\n            > .item:nth-of-type(6) > .dot {\n                animation-delay: 1.5s;\n            }\n\n            > .item:nth-of-type(3) > .dot {\n                animation-delay: 2s;\n            }\n\n            > .item:nth-of-type(5) > .dot {\n                animation-delay: 2.5s;\n            }\n\n            > .item:nth-of-type(4) > .dot {\n                animation-delay: 3s;\n            }\n\n            > .item:nth-of-type(8) > .dot {\n                animation-delay: 3.5s;\n            }\n\n            > .center {\n                position: absolute;\n                top: 50%;\n                left: 50%;\n                transform: translateX(-50%) translateY(-50%);\n                height: 50%;\n                width: 50%;\n            }\n\n            > .center > .circle {\n                position: absolute;\n                top: 50%;\n                left: 50%;\n                transform: translateX(-50%) translateY(-50%);\n                border-radius: 50%;\n            }\n\n            > .center > .circle:nth-child(1) {\n                height: 100%;\n                width: 100%;\n                background: $nitroLight;\n                box-shadow: 0 0 3vmin rgba(0, 0, 0, 0.5);\n            }\n\n            > .center > .circle:nth-child(2) {\n                height: 80%;\n                width: 80%;\n                border: 2px solid $nitroDark;\n            }\n\n            > .center > .circle:nth-child(3) {\n                height: 50%;\n                width: 50%;\n                background: $nitroDark;\n            }\n        }\n    }\n}\n\n.itemTable {\n    p {\n        text-align: center;\n        text-decoration: underline;\n        color: black;\n        font-weight: bolder;\n    }\n\n    table {\n        width: 90%;\n        margin: auto;\n        table-layout: fixed;\n        border-collapse: collapse;\n        background-color: #fff;\n        color: black;\n\n        thead {\n            background-color: $nitroDark;\n            color: #fff;\n        }\n\n        tbody {\n            tr {\n                border-bottom: 1px solid $fontColor;\n\n                @media (max-width: $mobile) {\n                    font-size: 0.6rem;\n                }\n\n                td {\n                    text-align: center;\n                }\n            }\n\n            .selected__row__shift {\n                background-color: $nitroDark;\n                color: #fff;\n            }\n        }\n    }\n}\n\n.summary {\n    display: flex;\n    justify-content: space-between;\n\n    @media (max-width: $mobile) {\n        display: block;\n\n        #itemSearch {\n            margin-left: -15%;\n            margin-bottom: -70%;\n        }\n\n        #catSearch {\n            margin-left: -38%;\n            margin-bottom: -195%;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
